import { render, staticRenderFns } from "./LoginRollBack.vue?vue&type=template&id=0244547f&scoped=true"
import script from "./LoginRollBack.vue?vue&type=script&lang=js"
export * from "./LoginRollBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244547f",
  null
  
)

export default component.exports